import Container = Phaser.GameObjects.Container;
import Scene = Phaser.Scene;
import {Creature} from "@/store/level/types";
import CreaturePanel from "@/scenes.ui/creature-panel";
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import BaseSound = Phaser.Sound.BaseSound;
import SoundUtils from "@/utils/sound-utils";
import {Fonts} from "@/constants/font";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class Checkbox extends Container {

    private checked!: boolean;

    constructor(scene: Scene, x: number, y: number, selectSound: BaseSound | undefined, name: string, checked: boolean, checkCallback: (checked: boolean) => unknown) {
        super(scene);
        let self = this;
        this.x = x * CU.S;
        this.y = y * CU.S;
        this.checked = checked;
        let box = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_PROFILE, Keys.UI_BOX);
        let check = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_PROFILE, Keys.UI_CHECK).setVisible(checked);

        let fn = () => {
            SoundUtils.play(selectSound);
            self.checked = !self.checked;
            check.setVisible(self.checked);
            checkCallback(self.checked);
        };

        box.setInteractive().on('pointerup', fn);

        let label = TextUtils.addTextAdvanced(this.scene, name.toUpperCase(), 20, 0,
            '#ffdfdf', 15, Fonts.MYRIADPRO_REGULAR, 500, 'left', 2, Fonts.MYRIADPRO_REGULAR);

        label.setInteractive().on('pointerup', fn);

        this.add([box, check, label]);
    }

}
